import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import './styles/globals.css'
import './styles/icons.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />,
) 